import { createFileRoute } from "@tanstack/react-router";
import CollegeStudentDepressionTreatment from "@/pages/CollegeStudentDepressionTreatment";
export const Route = createFileRoute("/college-student-depression-treatment")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "College Student Depression Treatment | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "College students face unique depression challenges. Learn about TMS, SAINT TMS, and treatment options for students in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "College Student Depression Treatment | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "College students face unique depression challenges. Learn about TMS, SAINT TMS, and treatment options for students in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/college-student-depression-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/college-student-depression-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CollegeStudentDepressionTreatment />;
}
